import { render } from "./TermsIndexView.vue?vue&type=template&id=0f759ce2"
import script from "./TermsIndexView.vue?vue&type=script&lang=js"
export * from "./TermsIndexView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__